document.addEventListener('DOMContentLoaded', function() {
  const portfolioSections = document.querySelectorAll('.tptai-our-latest-work');
  
  portfolioSections.forEach(section => {
    initializePortfolioTabs(section);
  });
});

function initializePortfolioTabs(section) {
  const tabs = section.querySelectorAll('.tptai-our-latest-work_tab');
  const tabContents = section.querySelectorAll('.tptai-our-latest-work_tab-content');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Hide all tab contents
      tabContents.forEach(content => {
        content.classList.remove('active');
      });
      
      // Show target tab content
      const targetContent = section.querySelector(`[data-content="${targetTab}"]`);
      if (targetContent) {
        targetContent.classList.add('active');
        
        // Reinitialize swiper for the active tab
        setTimeout(() => {
          reinitializeSwiper(targetContent);
        }, 300);
      }
    });
  });
  
  // Initialize swiper for the initially active tab
  const activeContent = section.querySelector('.tptai-our-latest-work_tab-content.active');
  if (activeContent) {
    setTimeout(() => {
      reinitializeSwiper(activeContent);
    }, 100);
  }
}

function reinitializeSwiper(tabContent) {
  const slider = tabContent.querySelector('tpt-slider');
  if (slider && slider.swiper) {
    slider.swiper.update();
    slider.swiper.slideTo(0, 0);
  }
}

// Handle window resize
window.addEventListener('resize', function() {
  const portfolioSections = document.querySelectorAll('.tptai-our-latest-work');
  
  portfolioSections.forEach(section => {
    const activeContent = section.querySelector('.tptai-our-latest-work_tab-content.active');
    if (activeContent) {
      reinitializeSwiper(activeContent);
    }
  });
});